import { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { LocationsFilter } from '~/components/Filters/LocationsFilter/LocationsFilter';
import { SingleFilterContainer } from '~/components/Filters/SingleFilters/SingleFilterContainer';
import { type SingleFilterProps } from '~/components/Filters/types';
import { clearLocationsFilterValuesAction } from '~/store/filters/actions';
import { hasLocationsFiltersValuesSelector } from '~/store/filters/selectors';
import { useAirSelector } from '~/utils/ReduxUtils';

export type SingleLocationsFilterProps = SingleFilterProps;

export const SingleLocationsFilter = memo(({ onApplyClick }: SingleLocationsFilterProps) => {
  const dispatch = useDispatch();
  const hasValues = useAirSelector(hasLocationsFiltersValuesSelector);

  const clearValues = useCallback(() => {
    dispatch(clearLocationsFilterValuesAction());
  }, [dispatch]);

  return (
    <SingleFilterContainer
      hasValues={hasValues}
      currentFilter="locations"
      onClearClick={clearValues}
      onApplyClick={onApplyClick}
    >
      <LocationsFilter onBoardSelect={onApplyClick} onLibrarySelect={onApplyClick} />
    </SingleFilterContainer>
  );
});

SingleLocationsFilter.displayName = 'SingleLocationsFilter';
